<div class="banner-content">
  <span class="client-name">
    {{ LL.coach.managingBannerLabel() }}
    @if (clientOnline !== undefined) {
      <span class="presence-dot" [class.online]="clientOnline"></span>
    }
    <strong>{{ clientDisplayName }}</strong>
  </span>
  <cs-button small secondary [label]="LL.coach.backToMyAccount()" (click)="backToMyAccount.emit()"></cs-button>
</div>
